import { FC } from "react";
import { ortexNewsStockUrl } from "@/lib/ortex-news";
import styles from "./SiteFooter.module.scss";

/**
 * Site footer with plain, followed links to the other ORTEX properties.
 *
 * app.ortex.com is the only ORTEX site with per-ticker pages, but it linked to
 * none of its sister sites in server HTML, so crawlers saw four unrelated
 * domains. On a stock page the footer also links that stock's ortex.news page,
 * tying the news coverage and the data page for one ticker together. The
 * exchange is upper-cased because that is the form ortex.news canonicalizes to.
 *
 * Rendered below <main> (inside the scrolling root) so it never takes height
 * from a full-screen grid.
 */

interface Props {
    stock?: { exchangesymbol: string; ticker: string; name?: string } | null;
}

const SiteFooter: FC<Props> = ({ stock }) => (
    <footer className={styles.SiteFooter}>
        <nav aria-label="ORTEX sites">
            <ul>
                {stock && (
                    <li>
                        <a href={ortexNewsStockUrl(stock.exchangesymbol, stock.ticker)}>{`${stock.ticker} news on ORTEX News`}</a>
                    </li>
                )}
                <li>
                    <a href="https://ortex.news">ORTEX News</a>
                </li>
                <li>
                    <a href="https://public.ortex.com">ORTEX public data</a>
                </li>
                <li>
                    <a href="https://ortexcharts.com">ORTEX Charts</a>
                </li>
                <li>
                    <a href="https://app.ortex.com/apis">ORTEX API</a>
                </li>
            </ul>
        </nav>
        <p>© {new Date().getUTCFullYear()} ORTEX Technologies Ltd.</p>
    </footer>
);

export default SiteFooter;
